/**
 * Copyright 2019-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import * as React from 'react';
import { checkUrl } from '../utilities/checkUrl';
import { Labels } from '../labels/Labels';

import './DetailName.scss';

function DetailName(props: any) {
  return (
    <div className="row">
      <div className="col-12 col-lg-5" />
      <div className="col-12 col-lg-7">
        <div className="hero-title">
          {props?.isOnline ? (
            <span className="icon-connection online" title={Labels.machineIsOnline} />
          ) : (
            <span className="icon-connection" title={Labels.machineIsOffline} />
          )}
          {checkUrl(props.name) ? (
            <strong>
              <a href={props.name}>{props.name}</a>
            </strong>
          ) : (
            <strong>{props.name}</strong>
          )}
          <h2 className="display-3">{props.model}</h2>
        </div>
      </div>
    </div>
  );
}

export default DetailName;
